export default {
  title: 'Horario de apertura',
  headers: {
    edit_time: 'Editar horario',
    create_time: 'Crear horario',
  },
  labels: {
    select_all: 'Seleccionar todo',
    timezone: 'Zona horaria',
  },
  fields: {
    selected_days: {
      label: 'Días seleccionados',
    },
    opening_time: {
      label: 'Hora de apertura',
    },
    closing_time: {
      label: 'Hora de cierre',
    },
  },
  columns: {
    days: 'Días',
    time: 'Hora',
  },
  buttons: {
    add_opening_time: 'Añadir horario de apertura',
    add: 'Añadir',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
    delete: 'Eliminar',
    sync_from_online_shop: 'Sincronizar desde la tienda online',
  },
  projects: {
    online_shop: 'Tienda online',
    reservations: 'Reservas',
    storefront: 'Escaparate',
    not_set_up: '{{project}} (no configurado para esta ubicación)',
  },
  feedback: {
    missing_info: 'Información faltante',
  },
  toasts: {
    saving_success: 'Guardado correctamente',
    saving_error: 'Error al guardar. Revisa tu información e inténtalo de nuevo.',
    sync_success: 'Sincronizado correctamente',
    sync_error: 'Error al sincronizar el horario de apertura desde la tienda online. Inténtalo de nuevo.',
    hours_required: 'El horario de apertura es obligatorio. Edita el horario existente',
    not_copied: {
      reservations: {
        not_set_up:
          'No se actualizaron las reservas: las reservas aún no están configuradas para esta ubicación. La pestaña Reservaciones explica por qué.',
        not_matched:
          'No se actualizaron las reservas: allí no existe el horario {{time}}. Revisa los horarios en la pestaña Reservaciones.',
        failed:
          'No se pudieron actualizar las reservas. Usa «Sincronizar desde la tienda online» en la pestaña Reservaciones.',
      },
      storefront: {
        not_set_up: 'No se actualizó el Escaparate: no se encontró ningún escaparate para esta ubicación.',
        not_matched:
          'No se actualizó el Escaparate: allí no existe el horario {{time}}. Revisa los horarios en la pestaña Tienda física.',
        failed:
          'No se pudo actualizar el Escaparate. Usa «Sincronizar desde la tienda online» en la pestaña Tienda física.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Zona horaria',
        },
      },
      toasts: {
        error: 'Error al actualizar la zona horaria',
      },
    },
  },
};
